module.exports = __webpack_public_path__ + "static/media/02_1440.ed286a2f.jpeg";